import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr';
import en from './locales/en';
import es from './locales/es';
import de from './locales/de';
import it from './locales/it';

// Détecter la langue sauvegardée ou utiliser français par défaut
const savedLanguage = localStorage.getItem('i18nextLng');
const defaultLanguage = savedLanguage || 'fr';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      es: { translation: es },
      de: { translation: de },
      it: { translation: it },
    },
    fallbackLng: 'fr',
    lng: defaultLanguage,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

// Forcer la langue française si aucune préférence n'est enregistrée
if (!savedLanguage) {
  i18n.changeLanguage('fr');
}

export default i18n;
